import { render } from "./newuser.vue?vue&type=template&id=11744c6c"
import script from "./newuser.vue?vue&type=script&lang=js"
export * from "./newuser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__